import React from 'react';
import { Shield, PlusCircle, Check } from 'lucide-react';
import { Header } from '../components/Header.js';
import { EduCard } from '../components/EduCard.js';
import { EduButton } from '../components/EduButton.js';
import { EduBadge } from '../components/EduBadge.js';

export const Admins: React.FC = () => {
  const admins = [
    {
      id: 'adm_01',
      name: 'Administrador Geral',
      email: 'admin@edurender.com.br',
      role: 'super_admin',
      roleName: 'Super Administrador',
      status: 'active',
      scope: 'Acesso Global Irrestrito',
    },
    {
      id: 'adm_02',
      name: 'Gestor Financeiro',
      email: 'financeiro@edurender.com.br',
      role: 'admin_financeiro',
      roleName: 'Administrador Financeiro',
      status: 'active',
      scope: 'Planos, Pagamentos e Assinaturas',
    },
    {
      id: 'adm_03',
      name: 'Engenheiro de Infraestrutura',
      email: 'operacoes@edurender.com.br',
      role: 'admin_operacional',
      roleName: 'Administrador Operacional',
      status: 'active',
      scope: 'Workers, Servidores e Filas',
    },
  ];

  return (
    <div>
      <Header
        title="Administradores do Sistema"
        subtitle="Gerenciamento de contas internas e atribuição de perfis de segurança"
        action={
          <EduButton
            variant="primary"
            size="sm"
            onClick={() => alert('Novo administrador')}
            icon={<PlusCircle size={16} />}
          >
            Novo Administrador
          </EduButton>
        }
      />

      <div className="p-8 max-w-7xl mx-auto space-y-6">
        <EduCard title="Usuários com Acesso Master">
          <div className="overflow-x-auto">
            <table className="w-full text-left text-xs border-collapse">
              <thead>
                <tr className="border-b border-bdr text-txt-secondary font-semibold bg-surface-secondary">
                  <th className="py-3 px-4">Nome</th>
                  <th className="py-3 px-4">E-mail</th>
                  <th className="py-3 px-4">Perfil</th>
                  <th className="py-3 px-4">Escopo de Autorização</th>
                  <th className="py-3 px-4">Status</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-bdr text-txt-primary">
                {admins.map((adm) => (
                  <tr key={adm.id} className="hover:bg-surface-secondary/40">
                    <td className="py-3 px-4 font-semibold text-txt-primary">{adm.name}</td>
                    <td className="py-3 px-4 font-mono text-txt-secondary">{adm.email}</td>
                    <td className="py-3 px-4">
                      <span className="font-semibold text-brand-primary">{adm.roleName}</span>
                    </td>
                    <td className="py-3 px-4 text-txt-secondary">{adm.scope}</td>
                    <td className="py-3 px-4">
                      <EduBadge variant="success" size="sm" dot>Ativo</EduBadge>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </EduCard>
      </div>
    </div>
  );
};
